// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_html2canvas_dist_html2canvas_js":"dfd7f1ae0ccf4a6f","node_modules_dompurify_dist_purify_js":"91359771370aadd0","node_modules_canvg_lib_index_es_js":"302f7098d58e875a"}[chunkId] + ".js";
};